var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "distribuicao az-card-bordered",
      class: { "distribuicao--loading": _vm.loading }
    },
    [
      !_vm.loading
        ? _c("div", { staticClass: "distribuicao__title az-ds-card-title" }, [
            _vm._v(" " + _vm._s(_vm.title) + " ")
          ])
        : _vm._e(),
      _c(
        "FeedbackWrapper",
        {
          attrs: {
            loading: _vm.loading,
            noData: _vm.hasNoData,
            message: _vm.WALLET_EMPTY_MESSAGE,
            minHeight: _vm.minHeight
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "distribuicao__chart-scroll",
              style: _vm.chartScrollStyle
            },
            [
              _c(
                "div",
                { style: { height: _vm.chartHeight + "px" } },
                [
                  _c("bar-horizontal-chart", {
                    attrs: {
                      "chart-data": _vm.horizontalChart.chartData,
                      options: _vm.horizontalChart.chartOptions,
                      plugins: _vm.horizontalChart.chartPlugins,
                      height: _vm.chartHeight
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }